import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { map } from 'rxjs/operators';
import { Category, PAGE_CONTENT } from '../shared/content';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-category',
  templateUrl: './category.component.html',
  styleUrls: ['./category.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CategoryComponent {
  public pageData$: Observable<Category>;
  public collapsed = false;

  constructor(private route: ActivatedRoute) {
    this.pageData$ = this.route.params
      .pipe(map((param: { id: string }) => PAGE_CONTENT.find((category: Category) => {
        this.collapsed = true;
        return category.url === param.id;
      })));
  }
}
